import { IConfigsType } from '../../types'

const drgConfig: IConfigsType = {
  drg: {
    '/:brand/sc_sandbox': {
      feV2ChatBox: {
        type: 'feV2-chatbox',
        agentType: 'location',
        hideFromNonExpoUsers: false,
        disableInputField: false,
        sendStoreId: false,
        useThinking: true,
        description: 'This is Sous Chef 2.0 Sandbox for developers.',
      },
    },
  },
}

export default drgConfig
